/*
 * "We can resize it" for sold-out ring sizes (snippets/ring-resize.liquid).
 * Runs after the theme updates the form on every variant change: if the picked
 * size is sold out but the same ring (same other options) is in stock within
 * 2.5 sizes, it re-enables Add to cart, points the form at the in-stock variant
 * and fills the "Resize to" property with the wanted size.
 */
(function () {
  if (window.ringResizeLoaded) return;
  window.ringResizeLoaded = true;

  function sizeOf(value) {
    var n = parseFloat(value);
    return isNaN(n) ? null : n;
  }

  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, whole)
      .replace(/\{\{\s*amount\s*\}\}/, whole + '.' + parts[1]);
  }

  // The closest in-stock variant that matches every other option, within maxSteps sizes.
  function findStocked(product, wanted, pos, maxSteps) {
    var wantedSize = sizeOf(wanted.options[pos]);
    if (wantedSize === null) return null;
    var best = null;
    var bestDiff = Infinity;
    product.variants.forEach(function (v) {
      if (!v.available || v.id === wanted.id) return;
      for (var i = 0; i < v.options.length; i++) {
        if (i !== pos && v.options[i] !== wanted.options[i]) return;
      }
      var size = sizeOf(v.options[pos]);
      if (size === null) return;
      var diff = Math.abs(size - wantedSize);
      if (diff <= maxSteps + 0.001 && diff < bestDiff) {
        best = v;
        bestDiff = diff;
      }
    });
    return best;
  }

  function apply(container, variant) {
    var box = container.querySelector('[data-ring-resize]');
    var jsonEl = container.querySelector('[data-product-json]');
    if (!box || !jsonEl) return;
    var product = box._product || (box._product = JSON.parse(jsonEl.innerHTML));
    var pos = parseInt(box.dataset.sizePosition, 10) - 1;
    var maxSteps = parseFloat(box.dataset.maxSteps) || 2.5;
    var input = box.querySelector('[data-ring-resize-input]');
    var note = box.querySelector('[data-ring-resize-note]');

    var stocked = variant && !variant.available ? findStocked(product, variant, pos, maxSteps) : null;

    if (!stocked) {
      box.hidden = true;
      input.disabled = true;
      input.value = '';
      return;
    }

    var wantedSize = variant.options[pos];
    var stockedSize = stocked.options[pos];
    input.value = wantedSize + ' (from size ' + stockedSize + ')';
    input.disabled = false;
    note.textContent = 'We have this ring in size ' + stockedSize + ' and will resize it to size ' + wantedSize + ' for you.';
    box.hidden = false;

    container.querySelectorAll('[data-form-wrapper]').forEach(function (wrapper) {
      wrapper.classList.remove('variant--soldout', 'variant--unavailable');
      wrapper.querySelectorAll('input[name="id"], select[name="id"]').forEach(function (el) {
        el.value = stocked.id;
      });
    });
    container.querySelectorAll('[data-add-to-cart]').forEach(function (btn) {
      if (btn.hasAttribute('data-quick-add-btn')) return;
      btn.disabled = false;
      btn.removeAttribute('disabled');
    });
    container.querySelectorAll('[data-add-to-cart-text]').forEach(function (el) {
      el.innerHTML = window.theme && window.theme.strings ? window.theme.strings.addToCart : 'Add to cart';
    });
    if (stocked.price !== variant.price) {
      container.querySelectorAll('[data-product-price]').forEach(function (el) {
        el.innerHTML = formatMoney(stocked.price);
      });
    }
  }

  // Size boxes for resizable sizes shouldn't look crossed out.
  function unmarkSizes(container) {
    var box = container.querySelector('[data-ring-resize]');
    if (!box || !box._product) return;
    var product = box._product;
    var pos = parseInt(box.dataset.sizePosition, 10) - 1;
    var maxSteps = parseFloat(box.dataset.maxSteps) || 2.5;
    var current = [];
    container.querySelectorAll('[data-option-position]').forEach(function (group) {
      var p = parseInt(group.getAttribute('data-option-position'), 10);
      if (isNaN(p)) return;
      var checked = group.querySelector('input:checked') || group.querySelector('[data-popout-input]');
      if (checked) current[p - 1] = checked.value;
    });
    var group = container.querySelector('[data-option-position="' + (pos + 1) + '"]');
    if (!group) return;
    group.querySelectorAll('input.sold-out').forEach(function (el) {
      var options = current.slice();
      options[pos] = el.value;
      var match = product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === options[i]; });
      });
      if (match && findStocked(product, match, pos, maxSteps)) el.classList.remove('sold-out');
    });
  }

  document.addEventListener('theme:variant:change', function (event) {
    var container = event.target;
    if (!container || !container.querySelector) return;
    apply(container, event.detail && event.detail.variant);
    // the theme marks sold-out boxes right after this event
    setTimeout(function () { unmarkSizes(container); }, 0);
  });

  function init() {
    document.querySelectorAll('[data-ring-resize]').forEach(function (box) {
      var container = (box.closest('[data-section-type]') || box.closest('[data-quick-add-modal]')) || document;
      var jsonEl = container.querySelector('[data-product-json]');
      if (!jsonEl) return;
      box._product = JSON.parse(jsonEl.innerHTML);
      var idInput = container.querySelector('[data-form-wrapper] [name="id"]');
      var id = idInput ? parseInt(idInput.value, 10) : null;
      var variant = box._product.variants.find(function (v) { return v.id === id; });
      if (variant) apply(container, variant);
      unmarkSizes(container);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 50); });
  } else {
    setTimeout(init, 50);
  }
})();
